<template>
  <div id="pressreview" >
  <!-- <playerBar :currentSong='formatMedia' > </playerBar> -->

  <div class="header">
    <el-row type="flex" justify="center" align="middle" :gutter="20" style="height:100%;">
      <el-col :xs="24" :sm="24" :md="22" :lg="14" class="header-tips">
        <audio class="header-tips-audio" :src="newContent.mediaurl" controls="controls" controlsList="nodownload" oncontextmenu="return false" v-if="newContent.mediaurl">
        您的浏览器不支持 audio 标签。
        </audio>
      </el-col>
    </el-row>
  </div>

  <el-row type="flex" justify="center" :gutter="20">
    <el-col :xs="24" :sm="24" :md="22" :lg="14">
    <div class="editor-content">

    <!-- <el-row>
        <el-col :span="24" class="el-item"> -->

            <div class="news-box">
                <div class="box-header" >
                    <span class="new-type fs-label">{{formatCategory}}</span>
                    <span class="hot-level fs-label">{{formatHotIndex}}</span>
                </div>
                <div class="box-title" >
                    <h1 class="fs-title">{{newContent.title}}</h1>
                </div>
                <div class="box-author fs-label" >
                  <span>{{newContent.date}}&nbsp;</span>
                  <span v-if="newContent.editorname">&nbsp;编:{{newContent.editorname}}</span>
                  <span v-if="newContent.hostname">&nbsp;播:{{newContent.hostname}}</span>
                  <span v-else-if="newContent.host">&nbsp;播:{{newContent.host}}</span>
                  <span v-if="newContent.verifiername">&nbsp;审:{{newContent.verifiername}}</span>
                </div>

                <div class="box-content">
                  <el-row type="flex" justify="center" :gutter="20">
                    <el-col :xs="20" :sm="20" :md="12" :lg="10">
                    <img class="box-image" :src="newContent.cover" v-show="newContent.cover"/>
                    </el-col>
                  </el-row>

                  <el-row type="flex" justify="center" :gutter="20">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                    <p class="box-text fs-text">{{newContent.content}}</p>
                    </el-col>
                  </el-row>
                </div>

                <div class="box-source fs-text" >
                  <span>新闻来源:</span>
                  <span>{{formatSourcefrom}}</span>
                </div>
                <div class="box-origin fs-text" >
                  <span>原文地址:</span><a :href="newContent.sourceurl" target="_blank">
                  <span class="link-url">{{newContent.sourceurl}}</span></a>
                </div>

                <div class="box-foot fs-label" >
                  <!-- <div v-for="(lable, index) in formatLabels" :key="index">
                    <span v-if="index === 0">{{lable}}</span>
                    <span v-else>&nbsp;/ {{lable}}</span>
                  </div> -->
                  <span>{{formatLabels2}}</span>
                </div>

                <el-row :gutter="20" class="pre-next-page">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <div>
                      <router-link :to="{ path: urladdr, query: {id:pressdata[preNewsId].id, index:preNewsId} }" v-if="preNewsId !== -1">
                        <p class="page-text fs-label">上一篇 {{pressdata[preNewsId].title}}</p>
                      </router-link>
                    </div>
                  </el-col>

                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <div>
                      <router-link :to="{ path: urladdr, query: {id:pressdata[nextNewsId].id, index:nextNewsId} }" v-if="nextNewsId !== -1">
                        <p class="page-text fs-label">下一篇 {{pressdata[nextNewsId].title}}</p>
                      </router-link>
                    </div>
                  </el-col>
                </el-row>
            </div>
        <!-- </el-col>
    </el-row> -->


    </div>

    </el-col>
</el-row>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import { newsType, hotsType, newsPlatform } from '../../config/config'
    import { getNowTime } from '../../utils/com.js'
    // import { markdownEditor } from 'vue-simplemde';
    import '../../static/style/press/review.scss'

    const playerBar = () => import('../common/playerbar.vue')

    export default {
        data: function(){
            return {
              //编辑界面数据
              editForm: {
                done: false,
                mediaurl: '',
                loading: false,
              },
              id: null,
              index: null,
              urladdr: './review',
            }
        },
        computed: {
          ...mapGetters({
              // 映射 this.newsdata 为 store.getters.newContent
              newContent: 'newContent',
              pressdata: 'pressdata',
              presstotal: 'presstotal',
              'getOsspolicy': 'getOsspolicy',
              'getOsskeyid': 'getOsskeyid',
              'getOsssign': 'getOsssign'
          }),
          formatCategory(){
            return newsType[this.newContent.category] || '';
          },
          formatLabels(){
            return this.newContent.labels.split('#') || [];
          },
          formatLabels2(){
            return this.newContent.labels.split('#').join(' / ') || '';
          },
          formatHotIndex(){
            return hotsType[this.newContent.hotindex+''];
          },
          formatSourcefrom(){
            return this.newContent.sourcefrom || '';
            // return newsPlatform[this.newContent.sourcefrom]|| '';
          },
          formatMedia(){
            return this.newContent.mediaurl || '';
          },
          preNewsId(){
            if(this.pressdata.length && this.pressdata.length> 0 && this.index > 0){
              // console.debug("preNewsId> index:%o, pre:%o", this.index, this.index-1);
              return this.index-1
            }else{
              // console.debug("preNewsId> -1");
              return -1
            }
          },
          nextNewsId(){
            if(this.pressdata.length && this.pressdata.length> 0 && this.index < this.pressdata.length-1){
              // console.debug("nextNewsId> index:%o, next:%o", this.index, this.index+1);
              return this.index + 1
            }else{
              // console.debug("nextNewsId> -1");
              return -1
            }
          }
        },
        created() {
          this.id = this.$route.query.id || '';
          let index = this.$route.query.index || 0;
          this.index = parseInt(index);
          // console.debug("created> id:%o, index:%o, pressdata:%o, statstotal:%o", this.id, this.index, this.pressdata, this.presstotal);
          let item = this.reqNewsContent(this.id, this.pressdata);
          // console.debug("created> item:%o", item);
          this.updateNewsContent(item);

          // console.debug("created> newContent:%o, getOsspolicy:%o, getOsskeyid:%o, getOsssign:%o", this.newContent, this.getOsspolicy, this.getOsskeyid, this.getOsssign);
          // if(this.newContent.mediaurl){
          //   this.editForm.mediaurl = this.newContent.mediaurl;
          // }
          // console.debug("created> editForm:%o", this.editForm);
        },
        watch: {
            '$route' (to, from){
                // console.debug("watch>route start to:%o, from:%o", to, from);
                // console.debug("watch route> id:%o, index:%o, pressdata:%o, presstotal:%o", this.id, this.index, this.pressdata, this.presstotal);

                this.id = this.$route.query.id || '';
                let index = this.$route.query.index || 0;
                this.index = parseInt(index);
                // console.debug("created> id:%o, index:%o, pressdata:%o, presstotal:%o", this.id, this.index, this.pressdata, this.presstotal);
                let item = this.reqNewsContent(this.id, this.pressdata);
                // console.debug("route> item:%o", item);
                this.updateNewsContent(item);
            }
        },
        methods: {
          ...mapActions({
            // 映射 this.editNewsContent() 为 this.$store.dispatch('editNewsContent')
            editNewsContent: 'editNewsContent',
            transferNewsState: 'transferNewsState',
            updateNewsContent: 'updateNewsContent',
          }),
          reqNewsContent(id, datalist) {
            // console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
            let data = null;
            let hasUser = datalist.some(u => {
              if (u.id === id ) {
                data = JSON.parse(JSON.stringify(u));
                return true;
              }
            });
            // console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
            return data;
          },
        },
        components: {
            // markdownEditor,
            playerBar,
        }
    }
</script>
<style scoped>
    .editor-btn{
        margin-top: 20px;
    }

    .header{
        background: white;
        /*padding: 0 20%;
        height: 50px;*/
        border-top: none;
        border-left: none;
        border-right: none;
        /*display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;*/
        position: fixed;
        z-index: 1;
        width: 100%;
        height: 3.6rem;
        border: 1px solid #939393;
        border-style: none none solid none;
    }
    .header .header-tips{
      /*font-size: 10px;
      color: #939393;*/
      /*width: 80%;*/
      /*border: 1px solid black;*/
      display: inline-flex;
      flex-direction: row;
      justify-content: flex-start;
    }
    .header .header-tips .header-tips-audio{
      /*border: 1px solid blue;*/
      width: 500px;
    }
    .header .header-btn{
      /*border: 1px solid black;*/
      width: 180px;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .editor-content{
      /*border: 1px solid blue;*/
      /*margin: 0 auto;*/
      /*width: 60%;*/
      /*height: 600px;*/
      padding: 3.6rem .8rem;
      background: white;
    }

    .input-new-tag{
      width: 120px;
    }

    .box-author{
      /*font-size: 10px;*/
      color: #939393;
      margin-bottom: 14px;
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #20a0ff;
    }
    .avatar-uploader-icon {
      /*font-size: 28px;*/
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }

</style>



// WEBPACK FOOTER //
// review.vue?4cb20ec8